import { Chip } from '@mui/material';
import type { UserRole } from '../../../types/auth';

interface UserRoleChipProps {
  role: UserRole;
}

const roleConfig: Record<UserRole, { label: string; color: 'default' | 'primary' | 'secondary' | 'info' | 'warning' | 'success' }> = {
  operator: { label: 'Operator', color: 'default' },
  supervisor: { label: 'Supervisor', color: 'primary' },
  researcher: { label: 'Researcher', color: 'info' },
  lab_manager: { label: 'Lab Manager', color: 'secondary' },
  'user-manager': { label: 'User Manager', color: 'warning' },
  admin: { label: 'Admin', color: 'secondary' },
};

export function UserRoleChip({ role }: UserRoleChipProps) {
  const config = roleConfig[role];
  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
    />
  );
}
